import { Plan, Product } from "@/types";
import { FC, ReactNode } from "react";
import clsx from "clsx";
import { FaArrowRight } from "react-icons/fa";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Button } from "./Buttons";
import { Link } from "react-router-dom";

const schema = Yup.object({
  email: Yup.string().email().required(),
});

type SelectPlanProps = {
  title: ReactNode;
  product: Product;
  plan?: Plan;
  onClickPlan: (plan: Plan) => void;
  onClickSubmit: ({ email }: { email: string }) => void;
};
export const SelectPlan: FC<SelectPlanProps> = ({
  title,
  product,
  plan,
  onClickPlan = () => null,
  onClickSubmit = () => null,
}) => {
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const email = watch("email");

  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-1 flex flex-col overflow-y-auto gap-10">
        <div className="font-dmSans text-white text-[38px] font-bold leading-[44px] inline-flex flex-col">
          {title}
        </div>

        <div className="flex flex-col gap-1">
          <div className="text-xl leading-[35px] font-medium text-white">
            How much money have you raised?
          </div>
          <div className="text-[#C2C2C2] leading-5 mb-5">
            Plans are based upon funds raised so we can ensure our pricing fits
            into every startup’s budget.
          </div>

          <div className="flex gap-3">
            {Object.values(product.plans).map(({ revenue, id }) => (
              <button
                key={id}
                className={clsx("flex-1 text-center btn-plan", {
                  active: plan?.id === id,
                })}
                onClick={() => onClickPlan(product.plans[id])}
              >
                <span className="text-[22px] leading-none text-secondary font-bold capitalize">
                  {id}
                </span>

                <span className="font-dmSans text-lg font-medium leading-none text-[#C6C6C6]">
                  {revenue}
                </span>
              </button>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit(onClickSubmit)}>
          <div className="flex flex-col gap-2">
            <label className="font-dmSans text-[24px] font-bold text-white leading-[45px]">
              Your Email*
            </label>

            <input className="input-email" {...register("email")} />
          </div>
        </form>
      </div>

      <div className="flex flex-col gap-5 mt-4 xl:mt-10">
        <Button
          className="flex items-center justify-center gap-2 md:px-12 py-5 text-xl md:text-2xl"
          onClick={handleSubmit(onClickSubmit)}
          disabled={!plan || !email}
          type="submit"
        >
          Continue
          <FaArrowRight />
        </Button>

        <Link
          className="text-white underline cursor-pointer font-bold leading-[45px] text-[19px] mx-auto"
          to="/pricing"
        >
          Show All Plans & Pricing
        </Link>
      </div>
    </div>
  );
};
